"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPrefixSuffix = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var PromptCloseCircleFill_1 = require("../Icons/PromptCloseCircleFill");
var byteLength_1 = require("../util/byteLength");
var reactNode_1 = require("../util/reactNode");
var types_1 = require("../util/types");
var utils_1 = require("./utils");
var ClearableInputType = (0, types_1.tuple)('text', 'input');
function hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}
exports.hasPrefixSuffix = hasPrefixSuffix;
function hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
var ClearableLabeledInput = /** @class */ (function (_super) {
    tslib_1.__extends(ClearableLabeledInput, _super);
    function ClearableLabeledInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @private Do not use out of this class. We do not promise this is always keep. */
        _this.containerRef = React.createRef();
        _this.onInputMouseUp = function (e) {
            var _a;
            if ((_a = _this.containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
                var triggerFocus = _this.props.triggerFocus;
                triggerFocus === null || triggerFocus === void 0 ? void 0 : triggerFocus();
            }
        };
        return _this;
    }
    ClearableLabeledInput.prototype.renderClearIcon = function (prefixCls) {
        var _a;
        var _b = this.props, allowClear = _b.allowClear, value = _b.value, disabled = _b.disabled, readOnly = _b.readOnly, handleReset = _b.handleReset;
        if (!allowClear) {
            return null;
        }
        var needClear = !disabled && !readOnly && value;
        var className = "".concat(prefixCls, "-clear-icon");
        return (React.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, { onClick: handleReset, className: (0, classnames_1.default)("".concat(prefixCls, "-suffix-item"), (_a = {},
                _a["".concat(className, "-hidden")] = !needClear,
                _a), className), role: "button" }));
    };
    ClearableLabeledInput.prototype.renderCount = function (prefixCls) {
        var _a;
        var _b = this.props, value = _b.value, maxLength = _b.maxLength, isChineseAsTwoBytes = _b.isChineseAsTwoBytes;
        var valStr = String(value || '');
        var valStrLength = isChineseAsTwoBytes ? (0, byteLength_1.byteLength)(valStr) : valStr.length;
        var overflowed = maxLength ? valStrLength >= maxLength : false;
        return (React.createElement("span", { className: (0, classnames_1.default)("".concat(prefixCls, "-length"), "".concat(prefixCls, "-suffix-item")) },
            React.createElement("span", { className: (0, classnames_1.default)("".concat(prefixCls, "-length-item"), (_a = {},
                    _a["".concat(prefixCls, "-length-none")] = valStrLength <= 0,
                    _a["".concat(prefixCls, "-length-cur")] = valStrLength > 0,
                    _a["".concat(prefixCls, "-length-over")] = overflowed,
                    _a)) }, valStrLength),
            React.createElement("span", { className: "".concat(prefixCls, "-length-item") },
                "/",
                maxLength)));
    };
    ClearableLabeledInput.prototype.renderSuffixItem = function (prefixCls, suffix) {
        if (typeof suffix === 'string' ||
            typeof suffix === 'number' ||
            typeof suffix === 'boolean' ||
            Array.isArray(suffix)) {
            return React.createElement("span", { className: "".concat(prefixCls, "-suffix-item") }, suffix);
        }
        return (0, reactNode_1.cloneElement)(suffix, {
            className: (0, classnames_1.default)("".concat(prefixCls, "-suffix-item"), suffix.props.className),
        });
    };
    ClearableLabeledInput.prototype.renderSuffix = function (prefixCls) {
        var _this = this;
        var _a = this.props, suffix = _a.suffix, allowClear = _a.allowClear, showCount = _a.showCount;
        if (suffix || allowClear || showCount) {
            return (React.createElement("span", { className: "".concat(prefixCls, "-suffix") },
                this.renderClearIcon(prefixCls),
                showCount && this.renderCount(prefixCls),
                Array.isArray(suffix)
                    ? suffix.map(function (suffixItem) { return _this.renderSuffixItem(prefixCls, suffixItem); })
                    : suffix
                        ? this.renderSuffixItem(prefixCls, suffix)
                        : null));
        }
        return null;
    };
    ClearableLabeledInput.prototype.renderLabeledIcon = function (prefixCls, element) {
        var _a;
        var _b = this.props, focused = _b.focused, value = _b.value, prefix = _b.prefix, className = _b.className, size = _b.size, suffix = _b.suffix, disabled = _b.disabled, allowClear = _b.allowClear, direction = _b.direction, style = _b.style, readOnly = _b.readOnly, bordered = _b.bordered;
        var suffixNode = this.renderSuffix(prefixCls);
        if (!hasPrefixSuffix(this.props)) {
            return (0, reactNode_1.cloneElement)(element, {
                value: value,
            });
        }
        var prefixNode = prefix ? React.createElement("span", { className: "".concat(prefixCls, "-prefix") }, prefix) : null;
        var affixWrapperCls = (0, classnames_1.default)("".concat(prefixCls, "-affix-wrapper"), (_a = {},
            _a["".concat(prefixCls, "-affix-wrapper-focused")] = focused,
            _a["".concat(prefixCls, "-affix-wrapper-disabled")] = disabled,
            _a["".concat(prefixCls, "-affix-wrapper-sm")] = size === 'small',
            _a["".concat(prefixCls, "-affix-wrapper-lg")] = size === 'large',
            _a["".concat(prefixCls, "-affix-wrapper-input-with-clear-btn")] = suffix && allowClear && value,
            _a["".concat(prefixCls, "-affix-wrapper-rtl")] = direction === 'rtl',
            _a["".concat(prefixCls, "-affix-wrapper-readonly")] = readOnly,
            _a["".concat(prefixCls, "-affix-wrapper-borderless")] = !bordered,
            // className will go to addon wrapper
            _a["".concat(className)] = !hasAddon(this.props) && className,
            _a));
        return (React.createElement("span", { ref: this.containerRef, className: affixWrapperCls, style: style, onMouseUp: this.onInputMouseUp },
            prefixNode,
            (0, reactNode_1.cloneElement)(element, {
                style: null,
                value: value,
                className: (0, utils_1.getInputClassName)(prefixCls, bordered, size, disabled),
            }),
            suffixNode));
    };
    ClearableLabeledInput.prototype.renderInputWithLabel = function (prefixCls, labeledElement) {
        var _a, _b;
        var _c = this.props, addonBefore = _c.addonBefore, addonAfter = _c.addonAfter, style = _c.style, size = _c.size, className = _c.className, direction = _c.direction;
        // Not wrap when there is not addons
        if (!hasAddon(this.props)) {
            return labeledElement;
        }
        var wrapperClassName = "".concat(prefixCls, "-group");
        var addonClassName = "".concat(wrapperClassName, "-addon");
        var addonBeforeNode = addonBefore ? (React.createElement("span", { className: addonClassName }, addonBefore)) : null;
        var addonAfterNode = addonAfter ? React.createElement("span", { className: addonClassName }, addonAfter) : null;
        var mergedWrapperClassName = (0, classnames_1.default)("".concat(prefixCls, "-wrapper"), wrapperClassName, (_a = {},
            _a["".concat(wrapperClassName, "-rtl")] = direction === 'rtl',
            _a));
        var mergedGroupClassName = (0, classnames_1.default)("".concat(prefixCls, "-group-wrapper"), (_b = {},
            _b["".concat(prefixCls, "-group-wrapper-sm")] = size === 'small',
            _b["".concat(prefixCls, "-group-wrapper-lg")] = size === 'large',
            _b["".concat(prefixCls, "-group-wrapper-rtl")] = direction === 'rtl',
            _b), className);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        return (React.createElement("span", { className: mergedGroupClassName, style: style },
            React.createElement("span", { className: mergedWrapperClassName },
                addonBeforeNode,
                (0, reactNode_1.cloneElement)(labeledElement, { style: null }),
                addonAfterNode)));
    };
    ClearableLabeledInput.prototype.renderTextAreaWithClearIcon = function (prefixCls, element) {
        var _a;
        var _b = this.props, value = _b.value, allowClear = _b.allowClear, className = _b.className, style = _b.style, direction = _b.direction, bordered = _b.bordered;
        if (!allowClear) {
            return (0, reactNode_1.cloneElement)(element, {
                value: value,
            });
        }
        var affixWrapperCls = (0, classnames_1.default)("".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"), (_a = {},
            _a["".concat(prefixCls, "-affix-wrapper-rtl")] = direction === 'rtl',
            _a["".concat(prefixCls, "-affix-wrapper-borderless")] = !bordered,
            // className will go to addon wrapper
            _a["".concat(className)] = !hasAddon(this.props) && className,
            _a));
        return (React.createElement("span", { className: affixWrapperCls, style: style },
            (0, reactNode_1.cloneElement)(element, {
                style: null,
                value: value,
            }),
            this.renderClearIcon(prefixCls)));
    };
    ClearableLabeledInput.prototype.render = function () {
        var _a = this.props, prefixCls = _a.prefixCls, inputType = _a.inputType, element = _a.element;
        if (inputType === ClearableInputType[0]) {
            return this.renderTextAreaWithClearIcon(prefixCls, element);
        }
        return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
    };
    return ClearableLabeledInput;
}(React.Component));
exports.default = ClearableLabeledInput;
//# sourceMappingURL=ClearableLabeledInput.js.map